export const MODULE = {
    DEVICES: 'devices',
    END_USERS: 'users',
    ACTIVITY_LOGS: 'activity logs'
};